import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { PADebug } from "./PADebug"
import * as ClientOAuth2 from "client-oauth2";

// LoadFromUrl - Loads a string, though it won't wait for the result but takes an event handler instead
function LoadFromUrlUni(url: string, onloaded: (s: string) => void, token?: ClientOAuth2.Token) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", url, true);
    if (token != null)
        Httpreq.setRequestHeader("Authorization", "Bearer " + token.accessToken);
    Httpreq.setRequestHeader("Content-Type", "charset=ISO-8859-1");
    // Httpreq.setRequestHeader("ContentEncoding", "text/plain; charset=ISO-8859-1");
    Httpreq.addEventListener("load", () => onloaded(Httpreq.responseText));
    Httpreq.send(null);
}

///////////////   HelpView  ////////////////

/* HelpView shows information and chapters of user help. */

export interface HelpViewVm  {
    app: App
}

export interface HelpViewStateVm {
    stage: string
}

export class HelpView extends React.Component<HelpViewVm, HelpViewStateVm> {

    constructor(props: HelpViewVm) {
        super(props)
        this.m_hoveredItem = -1
        this.m_selectedItem = -1
        this.m_pageBeingLoaded = -3 /*  -3 : entries not requested yet 
                                        -2 : entries requested but not loaded
                                        -1 : entries ready, pages may be loaded now. 
                                        0,1,2...  : A page is being loaded at the given index, all new requests will have to wait util its loaded. */
        this.m_entries = null
        this.m_pages = new Array<string>()
    }

    // 
    state = {
        stage: "initial"
    }

    // 
    componentWillMount() {
        this.props.app.GetCore().ConnectHelpView(this)
    }

    OnHoverChoise(choise: number) {
        this.m_hoveredItem = choise
        this.forceUpdate()
    }

    OnClickChoise(choise: number) {
        this.m_selectedItem = choise

        if (!this.m_pages[choise]) {

            if (this.m_entries) {

                if (choise < this.m_entries.length) {
                    var page = this.m_entries[choise].page
                    if (page) {
                        this.LoadPage(choise, page)
                    }
                }
            }
        }

        this.forceUpdate()
    }

    LoadEntries() {
        this.m_pageBeingLoaded = -2
        LoadFromUrlUni("items/helpFiles/entries.json", this.OnLoadEntries.bind(this), this.props.app.state.accessToken)
    }

    OnLoadEntries(entries: string) {
        this.m_pageBeingLoaded = -1

        var e: any

        try {
            e = JSON.parse(entries)
        }

        catch (e) {
            alert("Help view : ERROR - the entries file was not found within the helpFiles folder, or was not configured correctly. \nHere is a dump of what was found: " + entries)
        }

        this.m_entries = new Array<{ title: string | null, page: string | null }>()

        for (var i = 0; i < e.length; i++) {
            this.m_entries[i] = { title: e[i].title, page: e[i].page }
        }

        setTimeout(this.forceUpdate.bind(this), 40)
    }

    LoadPage(index: number, page: string) {
        if (this.m_pageBeingLoaded == -1) {
            this.m_pageBeingLoaded = index
            LoadFromUrlUni("items/helpFiles/pages/" + page, this.OnLoadPage.bind(this), this.props.app.state.accessToken)
        }
    }

    OnLoadPage(page: string) {
        this.m_pages[this.m_pageBeingLoaded] = page
        this.m_pageBeingLoaded = -1
    }

    // 
    render() {
        const core = this.props.app.GetCore() 
        const margin_Left = "20px"
        const contentMargin_Left = "50px"
        const contentMargin_Bottom = "15px"
        const itemHeight = "40px"
        const bgFile = "url(images/searchSettingsGraphics.png)"
        const iconTopMargin = "5px"
        const textTopMargin = "5px"
        const textLeftMargin = "5px"
        const iconWidth = "30px"
        const iconHeight = "30px"

        const iconPosOut = "-52px -18px"
        const iconPosHover = "-52px -69px"
        const iconPosLit = "-52px -43px"
        
        const subDefaultMarginLeft = "6px"
        
        if (this.m_pageBeingLoaded == -3) {
            this.LoadEntries()
        }

        if (this.m_pageBeingLoaded < -1) {
            return <div>Laster ned hjelpefiler...</div>
        }
        
        var helpChapters: Array<JSX.Element> = new Array<JSX.Element>() // A holder for all the help chapters

        var ch = 0 // chapter iterator

        if (this.m_entries) {
 
            for (ch = 0; ch < this.m_entries.length; ch++) {
                var imgPos = iconPosOut
                var content = <div></div>

                if (this.m_hoveredItem == ch) {
                    imgPos = iconPosHover
                }

                if (this.m_selectedItem == ch) {
                    imgPos = iconPosLit
                    var page = this.m_pages[ch]

                    if (page) {
                        var nordic = ""
                        
                        for (var nc = 0; nc < page.length; nc++) {
                            if (page.charAt(nc) == "#") {
                                if (nc < page.length + 1) {
                                    if (page.charAt(nc + 1) == "$") {
                                        nc++
                                        nordic += "#"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "a") {
                                        nc++
                                        nordic += "å"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "e") {
                                        nc++
                                        nordic += "æ"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "o") {
                                        nc++
                                        nordic += "ø"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "A") {
                                        nc++
                                        nordic += "Å"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "E") {
                                        nc++
                                        nordic += "Æ"
                                        continue
                                    }

                                    if (page.charAt(nc + 1) == "O") {
                                        nc++
                                        nordic += "Ø"
                                        continue
                                    }
                                }

                                nordic += "#"
                                continue
                            }
                            
                            if (page.charCodeAt(nc) == 65533) {
                                PADebug.Debug("Feil: HelpView.render - ukjennt tegn i html hjelpe fil, posisjon:" + nc + "\nBruk i stedet i html koden: #a for å, #e for æ, #o for ø, #A for Å, #E for Æ, #O for Ø")
                                nordic += page.charAt(nc)
                                continue
                            }
                            
                            nordic += page.charAt(nc)
                        }
                        
                        try {
                            content = <div style={{ marginLeft: contentMargin_Left, marginBottom: contentMargin_Bottom }}><div dangerouslySetInnerHTML={{ __html: nordic }} /></div>
                        }

                        catch (e) {
                            alert("page at index:" + ch + " crashed when trying to render its external html. \nDump:" + page)
                        }
                    }
                    else {
                        var page = this.m_entries[ch].page
                        if (page) {
                            this.LoadPage(ch, page)
                        }
                        else {
                            alert("Error - Helpview : missing help page url for chapter:" + this.m_entries[ch].title)
                        }
                        
                    }
                }
                
                const imgPosFinal = imgPos
                const finalContent = content
                const finalIndex = ch

                helpChapters.push(<div key={this.props.app.GetCore().GetUniqueKey()}>
                    <div onClick={(e) => this.OnClickChoise(finalIndex)} onMouseEnter={(e) => this.OnHoverChoise(finalIndex)} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                        <div style={{ width: margin_Left }}></div>
                        <div style={{ backgroundImage: bgFile, topMargin: iconTopMargin, backgroundPosition: imgPosFinal, width: iconWidth, height: iconHeight, cursor: "pointer" }}></div>
                        <div style={{ marginLeft: textLeftMargin, marginTop: textTopMargin, cursor: "pointer" }}>{this.m_entries[finalIndex].title}</div>
                    </div>
                    {finalContent}
                </div>)
                
            }

            // A few still hardcoded chapters..  

            // Om Prisassistenten
            var imgPos_about = iconPosOut
            var content_about = <div></div>
            const index_about = ch

            if (this.m_hoveredItem == index_about) {
                imgPos_about = iconPosHover
            }

            if (this.m_selectedItem == index_about) {
                imgPos_about = iconPosLit

                content_about = <div style={{ marginLeft: contentMargin_Left, marginBottom: contentMargin_Bottom }}>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Prisasstenten:</div>

                    <div style={{ marginLeft: subDefaultMarginLeft }}>Prisassistenten er opprinnelig et Windows program til bruk ved planlegging og innkjøp i bygnings prosjekter.</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Programmet gir oversikt over priser på materiell og varer.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Den nettbaserte versjon Prisassistenten Web har samme funksjonalitet, den krever ikke installasjon, og er klar</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>til bruk i en nettleser etter innlogging. Data blir lagret i nettskyen i stedet for på lokal maskin.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Dersom du oppdater til Prisassistenten Web Pro har du enda flere muligheter til å organisere dine prisvalg og lage</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>individualiserte bygningsdeler. En bygningsdel er en gjenbrukbar del av et bygningsprosjekt der du kan inkludere </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>varer og gi pris. En bygningsdel kan inneholde andre bygningsdeler.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Prisassistenten Web er utviklet av Byggdata AS og Focus Software AS.</div>
                    <div style={{ height: "15px" }}></div>
                </div>
            }

            ch++

            // Utvalg:
            const bgFileUtvalg = "url(images/selectionLoadButtons.png)"
            const finalIndexUtvalg = ch
            const loadButtonBGPos = "0px 0px"
            const mergeButtonBGPos = "-33px 0px"
            const delButtonBGPos = "-128px 0px"
            const buttonWidth = "33px"
            const buttonHeight = "29px"
            const subInfoMarginLeft = "42px"
            
            var loadButton = <div style={{ backgroundImage: bgFileUtvalg, backgroundPosition: loadButtonBGPos, width: buttonWidth, height: buttonHeight }}></div>
            var mergeButton = <div style={{ backgroundImage: bgFileUtvalg, backgroundPosition: mergeButtonBGPos, width: "31px", height: buttonHeight }}></div>
            var delButton = <div style={{ backgroundImage: bgFileUtvalg, backgroundPosition: delButtonBGPos, width: buttonWidth, height: buttonHeight }}></div>

            var content_utvalg = <div></div>
            if (this.m_selectedItem == finalIndexUtvalg) {
                content_utvalg = <div style={{ marginLeft: contentMargin_Left, marginBottom: contentMargin_Bottom }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>{loadButton} <div style={{ marginLeft: "10px", marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Åpne utvalg:</div></div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>Erstatter det som nå er i gjeldende utvalget med innholdet i det lagrede utvalget</div>
                    <div style={{ height: "15px" }}></div>

                    <div style={{ display: "flex", flexDirection: "row" }}>{mergeButton} <div style={{ marginLeft: "10px", marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Slå sammen utvalg:</div></div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>Legger til innholdet i det lagrede utvalget til hva som allerede finnes i gjeldende utvalg</div>
                    <div style={{ height: "15px" }}></div>

                    <div style={{ display: "flex", flexDirection: "row" }}>{delButton} <div style={{ marginLeft: "10px", marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Slette utvalg:</div></div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>Sletter dette lagrede utvalg fra bruker kontoen din</div>
                    <div style={{ height: "15px" }}></div>

                    <div style={{ marginLeft: subInfoMarginLeft, marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Om utvalg:</div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>Varer og bygningsdeler som finnes i åpent utvalg lagres ikke til brukerkontoen din hvis du ikke aktivt</div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>lagrer det som et utvalg etter at du har gjort dine endringer. Dersom du lagrer et utvalg med samme navn som</div>
                    <div style={{ marginLeft: subInfoMarginLeft }}>et tidligere lagret utvalg vil det tidligere utvalget erstattes.</div>
                    <div style={{ height: "15px" }}></div>
                </div>
            }

            var imgPos_utvalg = iconPosOut
            var content = <div></div>

            if (this.m_hoveredItem == finalIndexUtvalg) {
                imgPos_utvalg = iconPosHover
            }

            if (this.m_selectedItem == finalIndexUtvalg) {
                imgPos_utvalg = iconPosLit
            }
            
            ch++
            

            // Om utvidet vareinformasjon
            var imgPos_vareInfo = iconPosOut
            var content_vareInfo = <div></div>
            const index_vareInfo = ch

            if (this.m_hoveredItem == index_vareInfo) {
                imgPos_vareInfo = iconPosHover
            }

            if (this.m_selectedItem == index_vareInfo) {
                imgPos_vareInfo = iconPosLit

                content_vareInfo = <div style={{ marginLeft: contentMargin_Left, marginBottom: contentMargin_Bottom }}>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Utvidet vareinformasjon:</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Når du klikker på en vare vil et felt under varen vise utvidet vareinformasjon, forutsatt at utvidet</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>vareinformasjon er i synlig modus. Du kan veksle mellom å vise og skjule utvidet vareinformasjon for</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>valgt vare ved å klikke på knappen til venstre for kolonnen 'Antall':</div>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "8px", backgroundImage: "url(images/UtvidetInfoLocalArrow.png)", backgroundPosition: "0px -74px", height: "25px", width: "25px" }}></div>
                    <div style={{ height: "19px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Du kan og veksle mellom synlig og skjult vareinformasjon ved å klikke på 'Utvidet Vareinformasjon':</div>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "8px", backgroundImage: "url(images/ToolbarUtvidet.png)", backgroundPosition: "0px -3px", height: "29px", width: "30px" }}></div>
                    <div style={{ height: "15px" }}></div>
                </div>
            }

            ch++
            
            
            // Om vare søk
            const index_searchInfo = ch
            var imgPos_searchInfo = iconPosOut
            var content_searchInfo = <div></div>

            if (this.m_hoveredItem == index_searchInfo) {
                imgPos_searchInfo = iconPosHover
            }

            if (this.m_selectedItem == index_searchInfo) {
                imgPos_searchInfo = iconPosLit

                content_searchInfo = <div style={{ marginLeft: contentMargin_Left, marginBottom: contentMargin_Bottom }}>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Varesøk:</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Varesøk gjøres fra søkefeltet øverst på siden. Til høyre for søkefeltet kan du velge om søket skal gjøres på</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>valgt kategori eller alle kategorier. Valgt kategori er NOBB-kategorien som er valgt i trestrukturen til venstre.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Til venstre for søkefeltet er det en knapp for søkeinnstillinger der du kan velge hvilke felt som skal vare med i søket.</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Eks: Søk på varenummer, NOBB-nummer og varetekst1. </div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft, marginTop: "3px", fontWeight: "bold", fontSize: "16px" }}>Teknisk info:</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Ved oppstart av Prisassistenten Web vil søkedata automatisk lastes ned i bakgrunnen.  Dette kan ta noen få minutter å</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>laste ned hele prisboken, men velger du en specifik nobb kategori kommer den til å lastes ner først, sånn at du kan</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>begynne å gjøre søk innen valgt kategori før restparten av prisboken er innhentet fra serveren.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Før valgt kategori er lastet ned vil en grønn forløpsindikator vise status for nedlastningen. Søk kan utføres når</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>nedlastningen er ferdig.</div>
                    <div style={{ height: "9px" }}> </div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>Ved å gjøre det på denne måten vil alle data det søkes på være tilgjenglig i minnet på lokal maskin, noe som gir meget</div>
                    <div style={{ marginLeft: subDefaultMarginLeft }}>kjapp respons ved søk og blaing i resultater.</div>
                    <div style={{ height: "15px" }}></div>
                </div>
            }

            
            return <div onMouseLeave={(e) => this.OnHoverChoise(-1)} style={{ width: "100%" }}>
                <h2 style={{ marginLeft: "30px", marginTop: "20px" }}> Hjelpe avsnitt:</h2>
                <div style={{ marginLeft: "20px", marginTop: "20px" }}></div>

                {/* Om prisassistenten */}
                <div onClick={(e) => this.OnClickChoise(index_about)} onMouseEnter={(e) => this.OnHoverChoise(index_about)} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                    <div style={{ width: margin_Left }}></div>
                    <div style={{ backgroundImage: bgFile, topMargin: iconTopMargin, backgroundPosition: imgPos_about, width: iconWidth, height: iconHeight, cursor: "pointer" }}></div>
                    <div style={{ marginLeft: textLeftMargin, marginTop: textTopMargin, cursor: "pointer" }}>Om Prisassistenten</div>
                </div>
                {content_about}

                {/* Kapitel hentet fra html */}
                {helpChapters}

                {/* Utvalg */}
                <div onClick={(e) => this.OnClickChoise(finalIndexUtvalg)} onMouseEnter={(e) => this.OnHoverChoise(finalIndexUtvalg)} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                    <div style={{ width: margin_Left }}></div>
                    <div style={{ backgroundImage: bgFile, topMargin: iconTopMargin, backgroundPosition: imgPos_utvalg, width: iconWidth, height: iconHeight, cursor: "pointer" }}></div>
                    <div style={{ marginLeft: textLeftMargin, marginTop: textTopMargin, cursor: "pointer" }}>Hente og lagre utvalg</div>
                </div>
                {content_utvalg}

                {/* Vare info */}
                <div onClick={(e) => this.OnClickChoise(index_vareInfo)} onMouseEnter={(e) => this.OnHoverChoise(index_vareInfo)} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                    <div style={{ width: margin_Left }}></div>
                    <div style={{ backgroundImage: bgFile, topMargin: iconTopMargin, backgroundPosition: imgPos_vareInfo, width: iconWidth, height: iconHeight, cursor: "pointer" }}></div>
                    <div style={{ marginLeft: textLeftMargin, marginTop: textTopMargin, cursor: "pointer" }}>Om utvidet vareinformasjon</div>
                </div>
                {content_vareInfo}

                {/* Søk info */}
                <div onClick={(e) => this.OnClickChoise(index_searchInfo)} onMouseEnter={(e) => this.OnHoverChoise(index_searchInfo)} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                    <div style={{ width: margin_Left }}></div>
                    <div style={{ backgroundImage: bgFile, topMargin: iconTopMargin, backgroundPosition: imgPos_searchInfo, width: iconWidth, height: iconHeight, cursor: "pointer" }}></div>
                    <div style={{ marginLeft: textLeftMargin, marginTop: textTopMargin, cursor: "pointer" }}>Om vare søk</div>
                </div>
                {content_searchInfo}

            </div>
        }
        else {
            return <div>(Inga hjelpe avsnitt funnet!)</div>
        }
    }

    m_pageBeingLoaded: number
    m_hoveredItem: number
    m_selectedItem: number
    m_entries: Array<{ title: string | null, page: string | null }> | null
    m_pages:Array<string | null>
}



// WEBPACK FOOTER //
// ./client/view/HelpView.tsx